var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 21.5C8.63758 20.6163 6.66673 17.5925 5.68033 15.8214C5.25443 15.0567 5.47878 14.1173 6.16228 13.5705C6.92413 12.9611 8.02238 13.0219 8.71228 13.7118L9.50048 14.5V8.75C9.50048 8.05965 10.0601 7.5 10.7505 7.5C11.4408 7.5 12.0005 8.05965 12.0005 8.75V11.75C12.0005 11.0597 12.5601 10.5 13.2505 10.5C13.9408 10.5 14.5005 11.0597 14.5005 11.75V12.75C14.5005 12.0597 15.0601 11.5 15.7505 11.5C16.4408 11.5 17.0005 12.0597 17.0005 12.75V13.75C17.0005 13.0597 17.5601 12.5 18.2505 12.5C18.9408 12.5 19.5005 13.0597 19.5005 13.75V17.684C19.5005 18.2192 19.3682 18.748 19.0597 19.1854C18.5479 19.911 17.628 21.0168 16.5005 21.5C14.7505 22.25 13.1855 22.3171 11.0005 21.5Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4H16",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00015 6L5 4L7 2",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2L16 4L14 6",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.fafe707c9a5de7e2d3b0c6ce0a8550b1.svg";
export { ForwardRef as ReactComponent };